import { useState } from "react";
import React from "react";

export const multiStepContext = React.createContext({});
export const ServiceAvailContext = React.createContext({});
export const TokenContext = React.createContext({});
export const LangContext = React.createContext({});
export const LoadingContext = React.createContext({});
function UserContext({ children }: any) {
  const [activeStep, setActiveStep] = useState(1);
  const [ServiceNotAvail, setServiceNotAvail] = useState(false);
  const [tokenID, setTokenID] = useState("");
  const [language, setLanguage] = useState(true);
  const [isLoading, setIsLoading]=useState(false);
  return (
    <div >
      <multiStepContext.Provider value={{ activeStep, setActiveStep }}>
        <ServiceAvailContext.Provider value={{ ServiceNotAvail, setServiceNotAvail }}>
          <TokenContext.Provider value={{ tokenID, setTokenID }}>
            <LangContext.Provider value={{ language, setLanguage }}>
              <LoadingContext.Provider value={{isLoading, setIsLoading}}>
              {children}
              </LoadingContext.Provider>
            </LangContext.Provider>
          </TokenContext.Provider>
        </ServiceAvailContext.Provider>
      </multiStepContext.Provider>
    </div>
  );
}

export default UserContext;

